<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5gdhk6/tc-custom/9780802158017.jpg?1726519033295" alt="This image is the cover for the book Cardiff, by the Sea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cardiff, by the Sea
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Four brand-new novellas by the #1 <i>New York Times</i>-bestselling, National Book Award-winning</b><b> “grand mistress of ghoulishness” (<i>Publishers Weekly</i>).</b></p><p>An academic in Pennsylvania discovers a terrifying trauma from her past after inheriting a house in Cardiff, Maine from someone she has never heard of. A pubescent girl, overcome with loneliness, befriends a feral cat that becomes her protector from the increasingly aggressive males that surround her. A brilliant but shy college sophomore is distraught to discover that she’s pregnant, and the professor who takes her under his wing may not have innocent intentions. And a woman who marries into a family shattered by tragedy finds herself haunted by her predecessor’s voice, an inexplicably befouled well, and a compulsive attraction to a garage that took two lives.</p> In these psychologically daring, chillingly suspenseful pieces, the author of <i>We Were the Mulvaneys</i> and <i>Blonde</i> writes about women facing threats past and present, once again cementing her reputation for “great intelligence and dead-on imaginative powers” (<i>Los Angeles Times Book Review</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joyce Carol Oates
      </h2>
      
      <p class="authorDescription body article">Joyce Carol Oates is the author of over seventy books encompassing novels, poetry, criticism, story collections, plays, and essays. Her novel <I>Them </I>won the National Book Award in Fiction in 1970. Oates has been a member of the American Academy of Arts and Letters for more than three decades and currently holds the Roger S. Berlind Distinguished Professorship at Princeton University.&#160;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Atlantic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef62de4c